import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { WooOrderResponse } from '../../api/orders.api';
import type { CartLineItem } from '../cart/cart.slice';

export interface CheckoutFormData {
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  postcode: string;
  country: string;
  email: string;
  phone: string;
  paymentMethod: 'cod' | 'bacs' | 'webxpay';
}

export interface PlaceOrderRequestPayload {
  formData: CheckoutFormData;
  cartItems: CartLineItem[];
  navigate?: (path: string) => void;
  successPath?: string;
}

interface CheckoutState {
  loading: boolean;
  error: string | null;
  order: WooOrderResponse | null;
}

const initialState: CheckoutState = {
  loading: false,
  error: null,
  order: null,
};

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    placeOrderRequest(state, _action: PayloadAction<PlaceOrderRequestPayload>) {
      state.loading = true;
      state.error = null;
    },
    checkoutSuccess(state, action: PayloadAction<WooOrderResponse>) {
      state.loading = false;
      state.order = action.payload;
    },
    checkoutFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetCheckoutState(state) {
      state.loading = false;
      state.error = null;
      state.order = null;
    },
  },
});

export const { placeOrderRequest, checkoutSuccess, checkoutFailure, resetCheckoutState } = checkoutSlice.actions;
export const checkoutReducer = checkoutSlice.reducer;
export default checkoutSlice.reducer;
